export default "__VITE_ASSET__B8Ky_$7W__"